import {LitElement, html} from 'lit';
import {property, customElement} from 'lit/decorators.js';
import {Service} from '../../service/service.js';
import {DataManagementService} from '../../service/datamanagement/dataManagementService.js';
import {UnitService} from '../../service/unit/unitService.js';
import {ElementUtil} from '../../utils/elementUtil.js';
import {TimeUtil} from '../../utils/timeUtil.js';
import {StringUtil} from '../../utils/stringUtil.js';
import {UOMUtil} from '../../utils/uomUtil.js';
import {ImportUtil} from '../../utils/importUtil.js';
import {attachWorkspaceFilterState, readTypeAheadUnitState, restoreTypeAheadUnitState, resolveUnitByCode} from '../../utils/workspaceStateUtil.js';
import {RoutingService} from '../../service/routing/routingService.js';
import {BaseComponent} from '../basecomponent.js';
import {DataTools} from './dataTools.js';


/* global customElements */
class GPSLocationGrid extends BaseComponent {
	
	static get properties() {
		return {			
		};
	}
	
	constructor() {
		super();
		
		var gpsLocationGrid = this;
		setTimeout(function(){
			gpsLocationGrid.init();
		});
	}
	
	render() {	
		return html`
			<slot></slot>		
		`;
	}
	
	init() {
		var gpsLocationGrid = this;
		
		var lookupRequestId = 0;
		var loadReferenceLookup = function (refType, lookupValue, selectedUnitId) {
			var requestId = ++lookupRequestId;
			var paging = {
				max: 100
			};
			if (lookupValue) {
				paging.filterField = 'description';
				paging.filterValue = lookupValue;
			}

			return UnitService.getUnitLookupService().getUnits(refType, paging).then(function (units) {
				if (requestId !== lookupRequestId) {
					return;
				}

				units.data = units.data || [];

				var unitField = ElementUtil.query(toolbarFilter, 'filterTractorId');
				var applyItems = function(items) {
					if (requestId !== lookupRequestId) {
						return;
					}
					unitField.items = items;
					if (selectedUnitId) {
						unitField.value = selectedUnitId;
					}
				};

				if (selectedUnitId) {
					var found = units.data.some(function(unit) {
						return unit.code === selectedUnitId;
					});
					if (!found) {
						return UnitService.getUnitLookupService().getUnits(refType, {
							max: 1,
							filterField: 'code',
							filterValue: selectedUnitId
						}).then(function(matched) {
							if (matched && matched.data && matched.data.length) {
								units.data = matched.data.concat(units.data);
							}
							applyItems(units.data);
						});
					}
				}
				applyItems(units.data);
			});
		};		
		
		var toolbarFilter = ElementUtil.create({
			tag: 'dl-toolbar',
		'collapse-label': 'Filter',
			slot: 'toolbar',
			theme: 'spacing',			
			children: [											
				{										
					tag: 'vaadin-combo-box',
					itemid: 'filterTractorId',
					'class': 'spacer-toolbar-item',
					'keep-open': true,					
					style: 'width: 250px;',
					label: 'Tractor',
					'item-value-path': 'code',
					'item-label-path': 'description',
					required: true,					
					postinit: function(combo) {																	
					},
					placeHolder: 'Select',
					listeners: {
						input: {
							fn: function(e) {
								loadReferenceLookup('TRACTOR', e.target.value);	
							},
							buffer: 500
						},
						change: function() {
							actionRefresh();
						}
					}
				},
				{	
					tag: 'vaadin-combo-box',
					itemid: 'status',
					label: 'Status',
					'class': 'spacer-toolbar-item',
					'item-value-path': 'code',
					'item-label-path': 'desc',
					'prevent-invalid-input': true,
					postinit: function(combo) {							
						combo.items = [
							{
								code: 'A',
								desc: 'Active'
							}, {
								code: 'I',
								desc: 'Inactive'
							}
						];
						combo.value = 'A';
					},
					listeners: {
						'selected-item-changed': function(event) {
							if (actionRefresh){
								actionRefresh();
							}
						}
					}					
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterStartDate',
					label: 'Start Date',												
					name: 'filterStartDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.startPreviousMonth());	
					}()
				},
				{
					tag: 'vaadin-date-picker',
					'class': 'spacer-toolbar-item',
					itemid: 'filterEndDate',
					label: 'End Date',												
					name: 'filterEndDate',
					value: function() {
						return TimeUtil.formatDateForTimeField(TimeUtil.endPreviousMonth());	
					}()
				}				
			]
		});		
		
		var toolbar = ElementUtil.create({
			tag: 'dl-toolbar',
			slot: 'toolbar',
			theme: 'spacing',
			children: [
				{
					tag: 'vaadin-button',
					itemid: 'refresh',
					'class': 'spacer-toolbar-item',
					children:[
						ElementUtil.makeIcon('vaadin:refresh', ' Refresh')
					], 
					listeners: {
						click: function() {
							actionRefresh();
						}
					}
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'add',
					theme: 'primary',
					'class': 'spacer-toolbar-item',					
					permissions: ['GPS_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:plus', ' Add')						
					],
					listeners: {
						click: function() {
							actionAddEdit();
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'edit',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['GPS_MANAGEMENT:WRITE'],
					children:[
						ElementUtil.makeIcon('vaadin:edit', ' Edit')						
					],
					listeners: {
						click: function() {
							actionAddEdit(grid.selectedItems[0]);
						}
					}					
				},
				{
					tag: 'span',
					innerHTML: '|'
				},
				{
					tag: 'dl-action-button',
					itemid: 'showMap',
					'class': 'spacer-toolbar-item',
					disabled: true,	
					permissions: ['GPS_MANAGEMENT:READ'],
					children:[
						ElementUtil.makeIcon('vaadin:globe', ' Show on Map')						
					],
					listeners: {
						click: function() {
							actionShowMap(grid.selectedItems);
						}
					}					
				},
				{
					tag: 'dl-action-button',
					itemid: 'tools',
					'class': 'spacer-toolbar-item',
					disabled: true,
					permissions: ['GPS_MANAGEMENT:UPDATE_STATUS,GPS_MANAGEMENT:WRITE,GPS_MANAGEMENT:TIME_SHIFT,GPS_MANAGEMENT:FILTER,GPS_MANAGEMENT:RE_CALCULATE'],
					children:[
						ElementUtil.makeIcon('vaadin:cog', ' Tools')						
					],
					properties: {
						menu: [
							{
								tag: 'dl-action-menu-item',
								itemId: 'toggleStatus',							
								permissions: ['GPS_MANAGEMENT:UPDATE_STATUS'],							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:check"></vaadin-icon> Toogle Status',
								listeners: {
									click: function(event) {
										actionUpdateStatus(grid.selectedItems);
									}
								}
							},
							{
								tag: 'dl-action-menu-item',
								itemId: 'reReference',							
								permissions: ['GPS_MANAGEMENT:WRITE'],							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:arrow-right"></vaadin-icon> Re-Reference',
								listeners: {
									click: function(event) {
										actionReReference(grid.selectedItems);
									}
								}
							},							
							{
								tag: 'dl-action-menu-item',
								itemId: 'timeshift',
								permissions: ['GPS_MANAGEMENT:TIME_SHIFT'],							
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:clock"></vaadin-icon> Time Shift',
								listeners: {
									click: function(event) {
										actionTimeShift(grid.selectedItems);
									}
								}
							},							
							{
								tag: 'dl-action-menu-item',
								itemId: 'filter',
								permissions: ['GPS_MANAGEMENT:FILTER'],															
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:filter"></vaadin-icon> Filter',
								listeners: {
									click: function(event) {
										actionFilter(grid.selectedItems);	
									}
								}
							},							
							{
								tag: 'dl-action-menu-item',
								itemId: 'recalc',
								permissions: ['GPS_MANAGEMENT:RE_CALCULATE'],								
								trustedInnerHTML: true,
								innerHTML: '<vaadin-icon icon="vaadin:rotate-right"></vaadin-icon> Re-Calculate',
								listeners: {
									click: function(event) {
										actionReCalc(grid.selectedItems);	
									}
								}
							}
						]
					}
				},
				{
					tag: 'div',
					style: 'float: right;',
					children:[
						{
							tag: 'dl-action-button',
							itemid: 'bulk-tools',
							'class': 'spacer-toolbar-item',
							permissions: ['GPS_MANAGEMENT:FILTER,GPS_MANAGEMENT:TIME_SHIFT,GPS_MANAGEMENT:BULK_DELETE,GPS_MANAGEMENT:RE_CALCULATE'],
							children:[
								ElementUtil.makeIcon('vaadin:cogs', ' Bulk')						
							],
							properties: {
								menu: [																
									{
										tag: 'dl-action-menu-item',
										itemId: 'bulk-timeshift',
										permissions: ['GPS_MANAGEMENT:TIME_SHIFT'],
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:clock"></vaadin-icon> Time Shift',
										listeners: {
											click: function(event) {
												actionTimeShiftBulk();
											}
										}
									},									
									{
										tag: 'dl-action-menu-item',
										itemId: 'bulk-filter',
										permissions: ['GPS_MANAGEMENT:FILTER'],									
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:filter"></vaadin-icon> Filter',
										listeners: {
											click: function(event) {
												actionFilterBulk();	
											}
										}
									},									
									{
										tag: 'dl-action-menu-item',
										itemId: 'bulk-recalc',
										permissions: ['GPS_MANAGEMENT:RE_CALCULATE'],									
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:rotate-right"></vaadin-icon> Re-Calculate',
										listeners: {
											click: function(event) {
												actionReCalcBulk();	
											}
										}
									},
									{
										tag: 'hr'
									},
									{
										tag: 'dl-action-menu-item',
										itemId: 'bulk-delete',
										style: 'color: red',
										permissions: ['GPS_MANAGEMENT:BULK_DELETE'],
										trustedInnerHTML: true,
										innerHTML: '<vaadin-icon icon="vaadin:trash"></vaadin-icon> Delete',
										listeners: {
											click: function(event) {
												actionBulkDelete();
											}
										}
									}
								]
							}
						},
						{
							tag: 'dl-action-button',
							itemid: 'upload',
							'class': 'spacer-toolbar-item',					
							permissions: ['GPS_MANAGEMENT:WRITE'],						
							children:[
								ElementUtil.makeIcon('vaadin:upload', ' Import')						
							],
							listeners: {
								click: function() {
									actionUpload();
								}
							}							
						},
						{
							tag: 'span',
							innerHTML: '|'
						},
						{
							tag: 'dl-action-button',
							itemid: 'delete',
							'class': 'spacer-toolbar-item',	
							theme: 'error primary',
							permissions: ['GPS_MANAGEMENT:DELETE'],							
							children:[
								ElementUtil.makeIcon('vaadin:trash', ' Delete')						
							],
							listeners: {
								click: function() {
									actionDelete(grid.selectedItems);
								}
							}							
						}
					]
				}											
			]
		});		
		
		var toolbarContainer = ElementUtil.create({
			tag: 'div',
			slot: 'toolbar',
			children: [
				toolbarFilter,
				ElementUtil.create({
					tag: 'hr'
				}),
				toolbar
			]
		});			
	
		var grid = ElementUtil.create({
			tag: 'vaadin-grid',
			theme: 'row-stripes column-borders',
			'column-reordering-allowed': '',
			style: 'height: 100%;',			
			slot: 'primary',
			defaults: {
				tag: 'vaadin-grid-sort-column',
				resizable: true,
				listeners: {
					'direction-changed' : function(event) {
						if (event.detail && event.detail.value) {
							grid.currentSortField = event.target.path;
							grid.currentSortDirection = event.detail.value.toUpperCase();
							pagingToolbar.loadCurrentPage();
						}
					}
				}
			},			
			children: [
				{
					tag: 'vaadin-grid-selection-column',
					itemid: 'selectionColumn',
					'auto-select': true,
					'auto-width': true,
					listeners: {
						'select-all-changed': function() {
							gridSelectionChange();
						}
					}					
				},	
				{						
					path: 'recordDts',
					header: 'Date',
					width: '15em',					
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.recordDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);						
					}
				},
				{						
					path: 'location',
					header: 'Location',
					width: '10em',
					renderer: function(root, column, rowData) {
						root.innerHTML = rowData.item.location.addressLine1 + ' ' + rowData.item.location.city + ', ' + rowData.item.location.stateProv + ' ' + rowData.item.location.country; 
					}
				},
				{						
					path: 'location.heading',
					header: 'Heading',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'location.latitude',
					header: 'Latitude',
					width: '7em'
				},
				{						
					path: 'location.longitude',
					header: 'Longitude',
					width: '7em'
				},
				{						
					path: 'odometer',
					header: 'Odometer',
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.odometer && rowData.item.odometer.odometer) {
							root.innerHTML = rowData.item.odometer.odometer;
						} else {
							root.innerHTML = '';
						}
					}
				},
				{						
					path: 'totalDistance.distance',
					header: 'Distance (MI)',
					width: '7em'
				},
				{						
					path: 'totalDistance.tollDistance',
					header: 'Toll Distance (MI)',
					width: '7em'
				},
				{						
					path: 'calculationMethodDescription',
					header: 'Calculation Method',
					width: '7em'
				},
				{						
					path: 'vehicleStatus.currentFuelTankLevelPercent',
					header: 'Tank Level Percent',					
					width: '7em'
				},
				{						
					path: 'driverRefNo',
					header: 'Driver Ref No',					
					width: '7em'
				},				
				{						
					path: 'odometer.reset',
					header: 'Odometer Reset',
					width: '7em',
					hidden: true,
					renderer: function(root, column, rowData) {
						if (rowData.item.odometer) {
							root.innerHTML = rowData.item.odometer.resetRecord;
						} else {
							root.innerHTML = '';
						}
					}
				},
				{						
					path: 'entryMethodDescription',
					header: 'Entry Method',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'originalFilename',
					header: 'Original Filename',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'location.comment',
					header: 'Comment',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateUser',
					header: 'Update User',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'updateDts',
					header: 'Update Date',
					hidden: true,
					width: '7em',
					renderer: function(root, column, rowData) {
						var date = TimeUtil.parseDate(rowData.item.updateDts);						
						root.innerHTML = TimeUtil.formatDateStandard(date);
					}
				},
				{						
					path: 'totalDistance.ferryDistance',
					header: 'Ferry Distance (MI)',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'taxable',
					header: 'Taxable',
					hidden: true,
					width: '7em'
				},
				{						
					path: 'vehicleStatus.speed',
					header: 'Speed',
					hidden: true,
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.vehicleStatus.speed) {
							root.innerHTML = rowData.item.vehicleStatus.speed + ' ' + rowData.item.vehicleStatus.speedUOM;
						} else {
							root.innerHTML = '';
						}
					}
				},
				{						
					path: 'vehicleStatus.ignitionOn',
					header: 'Ignition/Engine On ',
					hidden: true,
					width: '7em', 
					renderer: function(root, column, rowData) {
						root.innerHTML = rowData.item.vehicleStatus.ignitionOn + ' / ' + rowData.item.vehicleStatus.engineOn;
					}
				},
				{						
					path: 'inMotion',
					header: 'In Motion',
					hidden: true,
					width: '7em'
				},				
				{						
					path: 'vehicleStatus.currentFuelTankLevel',
					header: 'Tank Level Amount',
					hidden: true,
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.vehicleStatus.currentFuelTankLevel) {
							root.innerHTML = rowData.item.vehicleStatus.currentFuelTankLevel + ' ' + rowData.item.vehicleStatus.tankLevelUom;
						} else {
							root.innerHTML = '';
						}
					}
				},
				{						
					path: 'vehicleStatus.engineTime',
					header: 'Total Engine Time',
					hidden: true,
					width: '7em',
					renderer: function(root, column, rowData) {
						if (rowData.item.vehicleStatus.engineTime) {
							root.innerHTML = rowData.item.vehicleStatus.engineTime + ' ' + rowData.item.vehicleStatus.engineTimeUom;
						} else {
							root.innerHTML = '';
						}
					}
				}
			],
			listeners: {
				'active-item-changed': function(event) {
					const item = event.detail.value;					
				},
				'click': function(e) {
					gridSelectionChange();
				}
			}
		});	
			
		var calcTotals = function(records) {			
			var totalDistance = 0;
			var totalToll = 0;
			var totalFerry = 0;
			records.forEach(function(record) {
				var distance = record.totalDistance.distance ? record.totalDistance.distance : 0;
				var toll = record.totalDistance.tollDistance ? record.totalDistance.tollDistance : 0;
				var ferry = record.totalDistance.ferryDistance ? record.totalDistance.ferryDistance : 0;
				
				if (record.distanceUom === 'KM') {
					totalDistance += UOMUtil.convertKMToMI(distance);
					totalToll += UOMUtil.convertKMToMI(toll);
					totalFerry += UOMUtil.convertKMToMI(ferry);
				} else {
					totalDistance += distance;
					totalToll += toll;
					totalFerry += ferry;
				}
			});
			return {
				totalDistance: Math.round(totalDistance * 10)/10,
				totalToll: Math.round(totalToll * 10)/10,
				totalFerry: Math.round(totalFerry * 10)/10
			};
		};				
			
		var gridSelectionChange = function() {
			setTimeout(function(){
				if (grid.selectedItems.length > 0) {
					if (grid.selectedItems.length === 1) {
						ElementUtil.query(toolbar, 'edit').disabled = false;
						ElementUtil.query(toolbar, 'delete').disabled = false;						
						ElementUtil.query(toolbar, 'showMap').disabled = false;
						ElementUtil.query(toolbar, 'tools').disabled = false;
					} else {
						ElementUtil.query(toolbar, 'edit').disabled = true;
						ElementUtil.query(toolbar, 'delete').disabled = false;
						ElementUtil.query(toolbar, 'showMap').disabled = false;
						ElementUtil.query(toolbar, 'tools').disabled = false;
					}
					
					var totals = calcTotals(grid.selectedItems);					
					selectedDistanceStatus.innerHTML = '<b>Selected Distance:</b> ' + totals.totalDistance + 
							' Toll: ' + totals.totalToll + 
							' Ferry: ' + totals.totalFerry + 
							' MI | ';
				} else {						
					ElementUtil.query(toolbar, 'edit').disabled = true;	
					ElementUtil.query(toolbar, 'delete').disabled = true;
					ElementUtil.query(toolbar, 'showMap').disabled = true;
					ElementUtil.query(toolbar, 'tools').disabled = true;
					
					selectedDistanceStatus.innerHTML = '';
				}					
			});
		};	
		
		var selectedDistanceStatus =  ElementUtil.create({
			tag: 'span'
		});
		
		var distanceStatus =  ElementUtil.create({
			tag: 'span',			
			trustedInnerHTML: true,
			innerHTML: '<b>Distance:</b> 0 MI'
		});				
		
		var exportToolbar = ElementUtil.create({
			tag: 'dl-export-toolbar',
			children: [
				{
					tag: 'span',
					slot: 'status',
					children: [
						selectedDistanceStatus,						
						distanceStatus
					]
				}
			],
			listeners: {
				ready: function() {
					exportToolbar.updateGrid(grid);
				},
				'click-detail': function() {
					var tractorId = ElementUtil.query(toolbarFilter, 'filterTractorId').value;
					if (tractorId) {
						DataManagementService.getGPSService().exportGPSLocations(tractorId, grid.currentFilter);
					} else {
						ElementUtil.query(toolbarFilter, 'filterTractorId').validate();								
						window.DL.MessageUtil.showToastError('A tractor must be selected');
					}
				}
			}
		});
		
		var pagingToolbar = ElementUtil.create({
			tag: 'dl-paging-toolbar',
			slot: 'footer',
			pageSize: 100,
			postinit: function(element) {
				element.grid = grid;
				element.loader = function(backingGrid, pageNumber, pagingToolbar) {
					var pageRange = pagingToolbar.pullRange();
					var loadMask = grid.showLoading();
										
					var loadData = function() {
						
						var startFilterDts = TimeUtil.startOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterStartDate').value);										
						var endFilterDts =  TimeUtil.endOfDayCompanyTime(ElementUtil.query(toolbarFilter, 'filterEndDate').value);						
						
						grid.currentFilter = {
							offset: pageRange.offset,
							max: pageRange.max,
							sortField: backingGrid.currentSortField ? backingGrid.currentSortField : 'recordDts',
							sortOrder: backingGrid.currentSortDirection	? backingGrid.currentSortDirection : 'ASC',
							status: ElementUtil.query(toolbarFilter, 'status').value,	
							start: startFilterDts,														
							end: endFilterDts,
							dateField: 'recordDts'
						};
																		
						var successHandler = function(records) {
							loadMask.remove();
							grid.activeItem = null;	
							grid.selectedItems = [];
							gridSelectionChange();
							
							grid.items = records.data;

							pagingToolbar.totalRecords = records.totalNumber;
							pagingToolbar.updatePager();
							
							var totalDistance = Math.round(records.totalDistance.distance * 10)/10;
							var totalTollDistance = Math.round(records.totalDistance.tollDistance * 10)/10;
							var totalFerryDistance = Math.round(records.totalDistance.ferryDistance * 10)/10;
																		
							distanceStatus.innerHTML = '<b>Distance:</b> ' + totalDistance + 
							' Toll: ' + totalTollDistance + 
							' Ferry: ' + totalFerryDistance + 
							' MI | ';							
											
						};
						
						var tractorId = ElementUtil.query(toolbarFilter, 'filterTractorId').value;
						if (tractorId) {						
							DataManagementService.getGPSService().getGPSLocations(tractorId, grid.currentFilter).then(function(records){
								successHandler(records);
							});						
						} else {
							loadMask.remove();
							if (gpsLocationGrid.nextLoadOfGrid) {
								ElementUtil.query(toolbarFilter, 'filterTractorId').validate();								
								window.DL.MessageUtil.showToastError('A tractor must be selected');
							} else {
								gpsLocationGrid.nextLoadOfGrid = true;
							}
						}
					};	
					
					loadData();														
				};
			},
			listeners: {
				ready: function() {					
					pagingToolbar.loadCurrentPage();					
				}
			}
			
		});			
		
		var footerContainer = ElementUtil.create({
			tag: 'div',
			slot: 'footer',
			children: [
				exportToolbar,
				{
					tag: 'div',
					style: 'border-top: 1px solid lightgrey;'
				},
				pagingToolbar
			]
		});
		
		var flexLayout = ElementUtil.create({
			tag: 'dl-flex-layout',
			children: [
				toolbarContainer,
				grid,
				footerContainer
			]
		});		
		gpsLocationGrid.append(flexLayout);	
		
		loadReferenceLookup('TRACTOR', '');
			
		var actionRefresh = function() {
			pagingToolbar.loadPage(1);	
		};

		gpsLocationGrid.toolbarFilter = toolbarFilter;
		gpsLocationGrid.pagingToolbar = pagingToolbar;
		attachWorkspaceFilterState(gpsLocationGrid, toolbarFilter,
			['filterTractorId','status','filterStartDate','filterEndDate'],
			actionRefresh,
			{
				save: function(state) {
					var unitState = readTypeAheadUnitState(ElementUtil.query(toolbarFilter, 'filterTractorId'));
					state.filterTractorId = unitState.value;
					state.filterTractorDescription = unitState.description;
				},
				restore: function(data) {
					if (data.status !== undefined && data.status !== null) {
						ElementUtil.query(toolbarFilter, 'status').value = data.status;
					}
					if (data.filterStartDate !== undefined && data.filterStartDate !== null) {
						ElementUtil.query(toolbarFilter, 'filterStartDate').value = data.filterStartDate;
					}
					if (data.filterEndDate !== undefined && data.filterEndDate !== null) {
						ElementUtil.query(toolbarFilter, 'filterEndDate').value = data.filterEndDate;
					}
					restoreTypeAheadUnitState({
						combo: ElementUtil.query(toolbarFilter, 'filterTractorId'),
						refType: 'TRACTOR',
						unitId: data.filterTractorId,
						description: data.filterTractorDescription,
						loadLookup: loadReferenceLookup,
						resolveByCode: function(type, unitId) {
							return resolveUnitByCode(function(referenceType, paging) {
								return UnitService.getUnitLookupService().getUnits(referenceType, paging);
							}, type, unitId);
						}
					}).then(function() {
						actionRefresh();
					});
				}
			});
				
		var actionAddEdit = function(record) {
			var addEditWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: record ? 'Edit GPS Location' : 'Add GPS Location',
				icon: 'vaadin:edit',				
				width: 700,
				height: 350,
				listeners: {
					ready: function() {						
						addEditWin.show();
						
						
						var loadReferenceNo = function (lookupValue, cbToPopulate, callback) {
							var paging = {
								max: 100
							};
							if (lookupValue) {
								paging.filterField = 'description';
								paging.filterValue = lookupValue;
							}
							UnitService.getUnitLookupService().getUnits('TRACTOR', paging).then(function (units) {
								cbToPopulate.items = units.data;
								if (callback) {
									callback(cbToPopulate);
								}
							});

						};
						
						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',										
									children: [										
										{
											tag: 'vaadin-combo-box',
											itemid: 'tractorId',
											label: 'Tractor',
											name: 'tractorId',
											'item-value-path': 'code',
											'item-label-path': 'description',
											required: true,											
											postinit: function (combo) {												
											},
											listeners: {
												input: {
													fn: function (e) {
														var refNoCB = ElementUtil.query(formPanel, 'tractorId');
														loadReferenceNo(ElementUtil.resolveComboInputValue(e, refNoCB), refNoCB);															
													},
													buffer: 500
												}
											}
										},
										{
											tag: 'vaadin-date-time-picker',
											label: 'Date(mm/dd/yyyy hh:mm:ss)',
											name: 'recordDts',
											step: 1,
											required: true
										},
										{
											tag: 'vaadin-combo-box',
											itemid: 'timezoneCB',
											label: 'TimeZone',
											name: 'timezone',
											'item-value-path': 'code',
											'item-label-path': 'description',
											value: TimeUtil.getCompanyTimeZoneNameOnly(),
											postinit: function (combo) {
												Service.getLookupService().getLookupValues('TimeZone').then(function (data) {
													combo.items = data;
												});
											}											
										},										
										{
											tag: 'div',
											children: [
												{
													tag: 'dl-location-lookup',
													itemid: 'locationLookup',
													textstyle: 'width: calc(100% - 40px)',
													name: 'rawLocation',
													required: true									
												}
											]
										},										
//										{
//											tag: 'vaadin-checkbox',
//											name: 'taxable',
//											label: 'Taxable',
//											checked: true
//										},										
										{
											tag: 'vaadin-number-field',												
											name: 'odometer',
											label: 'Odometer (MI)',										
											min: 0,
											max: 999999999
										},
										{
											tag: 'vaadin-text-field',										
											name: 'comment',
											label: 'Comment',											
											maxLength: 255											
										},											
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:database', ' Save')
													],
													listeners: {
														click: function() {															
															
															var timezone = ElementUtil.query(formPanel, 'timezoneCB').value;
															formPanel.submitForm({
																timezone: timezone,
																preSubmit: function(data) {																																		
																	return data;
																},
																actualCall: function(data) {			
																	if (record) {
																		data.recordId = record.recordId;
																	}																	
																	
																	return DataManagementService.getGPSService().saveGPSlocation(data, (record ? true : false));
																},
																success: function(data, responseData) {
																	window.DL.MessageUtil.showToast('Success', 'Saved GPS Location', {
																		theme: 'success',
																		position: 'top-stretch'
																	});
																	actionRefresh();
																	addEditWin.close();
																}
															});															
															
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function() {
															//cancel
															addEditWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});			
						
						addEditWin.addToContentElement(formPanel);
						
						var updateTractorCB = function() {
							var tractorIdFilter = ElementUtil.query(toolbarFilter, 'filterTractorId').selectedItem;
							var initialValue = null;
							if (tractorIdFilter) {
								initialValue = tractorIdFilter.description;
							}
							var refNoCB = ElementUtil.query(formPanel, 'tractorId');	
							loadReferenceNo(initialValue, refNoCB, function(cb) {
								if (tractorIdFilter) { 
									refNoCB.value = tractorIdFilter.code;
								}
							});
						};
						
						if (record) {	
							var formRecord = {
								tractorId: record.tractorId,
								recordDts: record.recordDts,		
								rawLocation: record.location.latitude + ', ' + record.location.longitude,
								odometer: record.odometer.odometer,
								comment: record.location.comment,
								taxable: record.taxable
							};
							var hasAddress = !!record.location.addressLine1;
							var hasLatLong = record.location.latitude && record.location.longitude;
							if (hasAddress) {
								var addressLocationParts = [record.location.addressLine1];
								if (record.location.city) {
									addressLocationParts.push(record.location.city);
								}
								if (record.location.stateProv) {
									addressLocationParts.push(record.location.stateProv);
								}
								formRecord.rawLocation = addressLocationParts.join(', ');
							} else if (hasLatLong) {
								formRecord.rawLocation = record.location.latitude + ', ' + record.location.longitude;
							} else if (record.location.stateProv) {
								formRecord.rawLocation = record.location.stateProv + '-' + (record.location.country || '');
							}
							//wait for render; shift to end of event loop
							setTimeout(function() {
								formPanel.load(formRecord);																							
								updateTractorCB();
								var locationLookup = ElementUtil.query(formPanel, 'locationLookup');
								var locationTextField = locationLookup ? ElementUtil.query(locationLookup, 'text') : null;
								if (locationTextField) {
									if (hasAddress && hasLatLong) {
										locationTextField.helperText = record.location.latitude + ', ' + record.location.longitude;
									} else if (!hasAddress && hasLatLong) {
										var locationHelperParts = [];
										if (record.location.city) {
											locationHelperParts.push(record.location.city);
										}
										if (record.location.stateProv) {
											locationHelperParts.push(record.location.stateProv);
										}
										locationTextField.helperText = locationHelperParts.join(' ');
									} else {
										locationTextField.helperText = '';
									}
								}
							});
						} else {
							updateTractorCB();							
						}
					}
				}
			});			
		};
		
		var actionDelete = function(records) {
			
			var multipleIds = {
				ids: []
			};
			records.forEach(function(record){
				multipleIds.ids.push(
					record.recordId
				);
			});
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Delete',
				message: 'Are you sure you want to delete selected records?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Removing...');

							DataManagementService.getGPSService().deleteGPSLocations(multipleIds)
							.then(function(result){
								loadMask.remove();
								window.DL.MessageUtil.showDeleteRecordsResult(result);
								actionRefresh();
							});
						}
					},
					{
						text: 'No'
					}
				]
			});
			
		};	
		
		var actionUpload = function() {
			ImportUtil.showUpload({
				dataTypes: 'GPS,GPS_FUEL',
				showGPSFilter: true,
				uploadUrl: '/api/resource/gpslocations/import'
			});
		};
		
		var actionShowMap = function(records) {
			var mapWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Map',
				icon: 'vaadin:globe',
				width: .75,
				height: .75,
				listeners: {
					ready: function() {
						mapWin.show();
						
						var map = ElementUtil.create({
							tag: 'dl-map-panel',
							slot: 'primary',
							style: 'width: 100%; height: 100%'
						});

						var toolbar = ElementUtil.create({
							tag: 'dl-toolbar',
							slot: 'toolbar',
							theme: 'spacing',
							children: [								
								{
									tag: 'dl-action-button',					
									'class': 'spacer-toolbar-item',
									style: 'width: 225px;',
									permissions: [],
									children:[
										ElementUtil.makeIcon('vaadin:cogs', ' View')
									],
									properties: {
										menu: [
											{
												tag: 'vaadin-item',						
												innerHTML: 'Show Satellite',
												listeners: {
													click: function(event) {
														map.showSatellite();
													}
												}
											},
											{
												tag: 'vaadin-item',						
												innerHTML: 'Show Terrain',
												listeners: {
													click: function(event) {
														map.showTerrain();
													}
												}
											},
											{
												tag: 'vaadin-item',						
												innerHTML: 'Show Transportation',
												listeners: {
													click: function(event) {
														map.showTransportation();
													}
												}
											}

										]
									}					
								}								
							]
						});						

						var mapFlexLayout = ElementUtil.create({
							tag: 'dl-flex-layout',
							children: [
								toolbar,
								map				
							]
						});	
						
						mapWin.addToContentElement(mapFlexLayout);
						
						//if 1 record; plot point
						setTimeout(function(){
							if (records.length === 1) {							
								var longLats = [records[0].location.longitude, records[0].location.latitude];

								var date = TimeUtil.parseDate(records[0].recordDts);						
								var info = TimeUtil.formatDateStandard(date) + '<br>' 
										+ records[0].location.addressLine1 + ' ' + records[0].location.city + ', ' + records[0].location.stateProv + ' ' + records[0].location.country + '<br>'
										+ records[0].location.latitude + ', ' + records[0].location.longitude;

								map.addMarker(longLats, {
									popupHTML: info
								});
								setTimeout(function() {
									map.zoomOnPoint(longLats);
								}, 1000);
							} else {
								records.sort(function(a, b){
									return TimeUtil.compare(a.recordDts, b.recordDts);
								});
										
								var loadMask = map.showLoading('Get Routing Options...');
								RoutingService.getGeospatialOptionsService().getOptionsForCurrentCompany().then(function(routeOptions){
									loadMask.remove();
									
									var request = map.translateRoutingOptions(routeOptions);
									request.routeId = ElementUtil.nextId();
									request.stops = [];
																		
									records.forEach(function (record) {
										request.stops.push({
											longitude: record.location.longitude,
											latitude: record.location.latitude
										});
									});

									map.route(request);
								});
								
							}
						}, 200);						

					}
				}
			});
		};
		
		var actionUpdateStatus = function(records) {
			
			var multipleIds = {
				ids: []
			};
			var activate = false;
			records.forEach(function(record){
				if (record.activeStatus === 'I') {
					activate = true;
				}
				multipleIds.ids.push(
					record.recordId
				);
			});
	
			window.DL.MessageUtil.showConfirm({
				title: 'Confirm Update',
				message: 'Are you sure you want to <b>' + (activate ? 'Activate' : 'Inactivate') + '</b> selected records?',
				buttons: [
					{
						text: 'Yes',
						handler: function() {
							var loadMask = grid.showLoading('Updating Status...');

							var successCallback = function() {
								loadMask.remove();
								window.DL.MessageUtil.showToast('Success', 'Updated: ' + multipleIds.ids.length + ' records', {									
									theme: 'success'
								});
								actionRefresh();
							};

							if (activate) {
								DataManagementService.getGPSService().activateGPSlocations(multipleIds)
								.then(function(){
									successCallback();
								});						
							} else {
								DataManagementService.getGPSService().inactivateGPSlocations(multipleIds)
								.then(function(){
									successCallback();
								});
							}
						}
					},
					{
						text: 'No'
					}
				]
			});
			
		};
		
		var actionReReference = function(records) {
			var primaryRecord = records[0];
			
			DataTools.referenceData({
				originalUnitId: primaryRecord.tractorId,
				referenceTypeOrigin: 'TRACTOR',
				referenceTypeFixed: true,
				proceed: function(data, successCallback, failCallback) {
					
					var transferRequest = {
						referenceTypeOrigin: 'TRACTOR',
						referenceTypeDestination: 'TRACTOR',
						originalUnitId: primaryRecord.tractorId,
						destinationUnitId: data.destinationUnitId,
						dataToReReference: records
					};
					
					DataManagementService.getGPSService().reReferenceGPSlocations(transferRequest).then(function(result){
						if (result.success) {							
							actionRefresh();
							if (successCallback) {
								successCallback(result);
							}							
						} else {														
							if (failCallback) {
								failCallback(result);
							}
						}
					});
					
				} 
			});
		};
		
		var actionTimeShift = function(records) {
					
			var unitId = records[0].tractorId;			
			records.sort(function(a, b) {
				return TimeUtil.compare(a.recordDts, b.recordDts);	
			});
						
			var startDts = records[0].recordDts;
			var endDts = records[records.length-1].recordDts;
						
			DataTools.timeShiftData({				
				proceed: function(data, successCallback, failCallback) {					
					data.dataType = 'GPS';		
					data.dataStartDts = startDts;
					data.dataEndDts = endDts;
					data.unitSelection = {
						type: 'CUSTOM',
						customList: [
							{
								unitId: unitId,
								referenceType: 'TRACTOR'
							}
						]
					};
					
					DataManagementService.getGPSService().timeshiftGPSlocations(data).then(function(result){
						if (result.success) {							
							actionRefresh();
							if (successCallback) {
								successCallback(result);
							}							
						} else {														
							if (failCallback) {
								failCallback(result);
							}
						}
					});
				}
			});
			
		};
		
		var actionFilter = function(records, bulk) {
			
			var bulkWin = ElementUtil.create({
				tag: 'dl-dialog',
				title: 'Filter GPS Records',
				icon: 'vaadin:filter',
				width: 700,
				height: 400,
				listeners: {
					ready: function () {
						bulkWin.show();

						var formPanel = ElementUtil.create({
							tag: 'dl-form-panel',
							itemid: 'form',
							children: [
								{
									tag: 'vaadin-form-layout',
									children: [
										{
											tag: 'dl-unitselection',
											itemId: 'unitSelection',
											'class': (bulk ? '' : 'hide'),
											properties: {
												showReportOptions: false
											},
											colspan: 2
										},
										{
											tag: 'vaadin-date-time-picker',
											label: 'Date(mm/dd/yyyy hh:mm:ss)',
											name: 'startDts',
											'class': (bulk ? '' : 'hide'),
											step: 1,
											value: TimeUtil.formatDateForDateLoad(new Date()) + 'T00:00:00',
											required: true
										},
										{
											tag: 'vaadin-date-time-picker',
											label: 'Date(mm/dd/yyyy hh:mm:ss)',
											name: 'endDts',
											'class': (bulk ? '' : 'hide'),
											step: 1,
											value: TimeUtil.formatDateForDateLoad(new Date()) + 'T00:00:00',
											required: true
										},										
										{
											tag: 'vaadin-combo-box',
											itemid: 'filtersCB',
											label: 'GPS Filter',
											name: 'gpsFilterId',
											'item-value-path': 'gpsFilterId',
											'item-label-path': 'name',
											placeHolder: 'Default',											
											postinit: function (combo) {
												DataManagementService.getGPSFilteringService().getGPSFilters().then(function (data) {													
													combo.items = data;
												});
											}
										},
										{
											tag: 'hr',
											colspan: 2
										},
										{
											tag: 'div',
											style: 'text-align: center;',
											colspan: 2,
											defaults: {
												tag: 'vaadin-button'
											},
											children: [
												{
													theme: 'primary',
													children: [
														ElementUtil.makeIcon('vaadin:arrow-right', ' Filter')
													],
													listeners: {
														click: function () {

															if (formPanel.isValid()) {
																var data = formPanel.getData();
																
																if (bulk) {
																	data.unitSelection = ElementUtil.query(formPanel, 'unitSelection').unitSelectionValue();
																} else {
																	var unitId = records[0].tractorId;
																	records.sort(function (a, b) {
																		return TimeUtil.compare(a.recordDts, b.recordDts);
																	});

																	var startDts = records[0].recordDts;
																	var endDts = records[records.length - 1].recordDts;
																	
																	data.startDts = startDts;
																	data.endDts = endDts;
																	data.unitSelection = {
																		type: 'CUSTOM',
																		customList: [																			
																			{																				
																				unitId: unitId,
																				referenceType: 'TRACTOR'
																			}
																		]
																	};
																}																
																
																DataManagementService.getGPSService().filterGPSlocations(data).then(function(result){
																	if (result.success) {
																		actionRefresh();
																		window.DL.MessageUtil.showToast('Success', 'Add task to filter records', {
																			theme: 'success',
																			position: 'top-stretch'
																		});
																		bulkWin.close();
																	} else {
																		var errors = [];
																		for (var key in result.errors) {
																			errors.push(key + " - " + result.errors[key]);
																		}
																		window.DL.MessageUtil.showToastError('Failed to submit filter task.<br>' + errors);
																	}
																});
																
															}
														}
													}
												},
												{
													theme: 'tertiary',
													innerHTML: 'Cancel',
													style: 'margin-left: 10px;',
													listeners: {
														click: function () {															
															bulkWin.close();
														}
													}
												}
											]
										}
									]
								}
							]
						});

						bulkWin.addToContentElement(formPanel);

					}
				}
			});
						
		};
		
		var actionReCalc = function(records) {
			
			DataTools.recalculate({
				proceed: function(data, successCallback, failCallback) {	
					
					var unitId = records[0].tractorId;
					records.sort(function (a, b) {
						return TimeUtil.compare(a.recordDts, b.recordDts);
					});

					var startDts = records[0].recordDts;
					var endDts = records[records.length - 1].recordDts;
					
					data.startDts = startDts;
					data.endDts = endDts;
					data.unitSelection = {
						type: 'CUSTOM',
						referenceType: 'TRACTOR',
						customList: [
							{
								unitId: unitId,
								referenceType: 'TRACTOR'
							}
						]
					};
					
					DataManagementService.getGPSService().recalcGPS(data).then(function(result){
						if (result.success) {							
							actionRefresh();
							if (successCallback) {
								successCallback(result);
							}							
						} else {														
							if (failCallback) {
								failCallback(result);
							}
						}
					});
				}
			});
		};
		
		var actionTimeShiftBulk = function() {
			DataTools.timeShiftData({
				bulk: true,
				proceed: function(data, successCallback, failCallback) {					
					data.dataType = 'GPS';					
										
					DataManagementService.getGPSService().timeshiftGPSlocations(data).then(function(result){
						if (result.success) {							
							actionRefresh();
							if (successCallback) {
								successCallback(result);
							}							
						} else {														
							if (failCallback) {
								failCallback(result);
							}
						}
					});
				}
			});
		};
		
		var actionFilterBulk = function() {
			actionFilter(null, true);			
		};
		
		var actionReCalcBulk = function() {
			
			DataTools.recalculate({
				bulk: true,
				proceed: function(data, successCallback, failCallback) {	
					
					DataManagementService.getGPSService().recalcGPS(data).then(function(result){
						if (result.success) {							
							actionRefresh();
							if (successCallback) {
								successCallback(result);
							}							
						} else {														
							if (failCallback) {
								failCallback(result);
							}
						}
					});
				}				
			});
			
		};
		
		var actionBulkDelete = function() {
			
			DataTools.deleteData({
				bulk: true,
				proceed: function(data, successCallback, failCallback) {	
					
					DataManagementService.getGPSService().deleteBulkGPSLocations(data).then(function(result){
						if (result.success) {							
							actionRefresh();
							if (successCallback) {
								successCallback(result);
							}							
						} else {														
							if (failCallback) {
								failCallback(result);
							}
						}
					});
				}
			});
		};
		
	}
	
}
customElements.define('dl-gpslocations-grid', GPSLocationGrid);
